export default {
  path: '/auth',
  name: 'auth',
  redirect: { name: 'auth.login-page' },
  component: () => import(/* webpackChunkName: "auth" */ '@/views/auth'),
  children: [
    {
      path: '/change-password',
      name: 'auth.change-password-page',
      component: () =>
        import(
          /* webpackChunkName: "change-password" */ '@/views/auth/ChangePasswordPage.vue'
        ),
    },
    {
      path: '/login',
      name: 'auth.login-page',
      component: () =>
        import(/* webpackChunkName: "login" */ '@/views/auth/LoginPage.vue'),
    },
    {
      path: '/mfa',
      name: 'auth.mfa-page',
      component: () =>
        import(/* webpackChunkName: "mfa" */ '@/views/auth/MfaPage.vue'),
    },
    {
      path: '/forgot-password',
      name: 'auth.forgot-password-page',
      component: () =>
        import(
          /* webpackChunkName: "forgot-password" */ '@/views/auth/ForgotPasswordPage.vue'
        ),
    },
    {
      path: '/reset-password',
      name: 'auth.reset-password-page',
      component: () =>
        import(
          /* webpackChunkName: "reset-password" */ '@/views/auth/ResetPasswordPage.vue'
        ),
    },
    {
      path: '/signup',
      name: 'auth.register-page',
      component: () =>
        import(
          /* webpackChunkName: "register" */ '@/views/auth/RegisterPage.vue'
        ),
    },
    {
      path: '/account-type-select',
      name: 'auth.account-type-selection-page',
      component: () =>
        import(
          /* webpackChunkName: "account-type-select" */ '@/views/auth/AccountTypeSelectionPage.vue'
        ),
    },
    {
      path: '/onboarding-tradie',
      name: 'auth.onboarding-tradie',
      component: () =>
        import(
          /* webpackChunkName: "onboarding-tradie" */ '@/views/auth/OnboardingTradiePage.vue'
        ),
    },
    {
      path: '/onboarding-company',
      name: 'auth.onboarding-company',
      component: () =>
        import(
          /* webpackChunkName: "onboarding-company" */ '@/views/auth/OnboardingCompanyPage.vue'
        ),
    },
    {
      path: '/verify/:account',
      name: 'auth.verify-page',
      component: () => import('@/views/auth/VerifyPage.vue'),
    },
  ],
}
